export const Menu = {
  Home: "/",
  Öffnungszeiten: "/#oeffnungszeiten",
  "Schießtermin buchen": "/BuchungsHinweis#title",
  Preisliste: "/Preisliste#title",
  Kalender: "/Kalender#title",
  Standaufsichten: "/Standaufsichten#title",
  Dokumente: "/Dokumente#title",
  Chronik: "/Chronik#title",
};
